// extracted by mini-css-extract-plugin
export default {"item":"TopCountries_item__DJ1Qd","flag":"TopCountries_flag__i5Fp2","price":"TopCountries_price__1Yco9"};